var IASNoneLeftExtension = function(a) {
    return a = jQuery.extend({}, this.defaults, a), this.ias = null, this.uid = (new Date).getTime(), this.html = a.html.replace("{text}", a.text), this.showNoneLeft = function() {
        var a = jQuery(this.html).attr("id", "ias_noneleft_" + this.uid),
            b = this.ias.getLastItem();
        b.after(a), a.fadeIn()
    }, this
};
IASNoneLeftExtension.prototype.bind = function(a) {
    this.ias = a, a.on("noneLeft", jQuery.proxy(this.showNoneLeft, this))
}, IASNoneLeftExtension.prototype.unbind = function(a) {
    a.off("noneLeft", this.showNoneLeft)
}, IASNoneLeftExtension.prototype.defaults = {
    text: "You reached the end.",
    html: '<div class="ias-noneleft" style="text-align: center;"><span>{text}</span></div>'
};